export const formatQuantity = (quantity, units) => {
  if (!quantity) return null;
  if (["nd", "nd."].includes(quantity.toLowerCase())) return null;

  // Check if units are "ND" or null, and return the formatted string
  return `${quantity}${["ND", null, undefined].includes(units) ? "" : units}`;
};
